<div class="container">
  <mat-card class="intro-card">
    <mat-card-header>
      <mat-card-title>Aman Gupta</mat-card-title>
      <mat-card-subtitle>Full Stack Web Developer</mat-card-subtitle>
    </mat-card-header>
    <img mat-card-image class="img" src="assets/img/Aman_Vidhan_Sabha.jpeg" alt="Aman Gupta">
    <mat-card-content>
      <div class="content-pad">{{intro.name}}</div>
      <div class="content-pad">{{intro.currentWork}}</div>
      <div class="content-pad">{{intro.likes}}</div>
      <div class="content-pad">{{intro.lookingFor}}</div>
    </mat-card-content>
  </mat-card>
</div>
